<!--<h3>{{this.FieldTypeName}}</h3>-->

@if (this.Mode === 'design') {
  <div class="flex-row-top-right">
    <div class="fill-remaining-space">
      @if (this.ShowLabel) {
        <mat-label
          class="design-mode-field-label"
        style="{{this.IndentationStyle}}">{{this.DescriptiveDisplayName}}</mat-label>
      }
      <!-- Note:  only one of the following *ngIf conditions will be true. -->
      <!-- If we do not have a configuration, give the user a hint. -->
      @if (this.ShowConfigurationHint) {
        <div
          class="has-no-config-div">
          <p class="user-tip-p">{{this.ConfigurationHintText}}</p>
        </div>
      }
      <!-- If we have selected role names, display them. -->
      @if (!this.ShowConfigurationHint) {
        <div
          class="has-config-div"
          style="{{this.IndentationStyle}}">
          @if (this.ShowConfiguredRoleNames) {
            <span class="configured-roles-label">Configured Roles:</span><span class="configured-roles-span">{{this.ConfiguredRoleNames}}</span>
          }
          @if (this.DebugMode) {
            <span class="debug-nesting-level-span">Nesting Level: </span><span>{{this.ConditionalNestingLevel}}</span>
          }
        </div>
      }
    </div>
  </div>
}

